import { defineComponent as t, openBlock as o, createElementBlock as n, renderSlot as a } from "vue";
import "./ghl-ui.es188.js";
const l = { class: "hl-modal-content" };
t({
  name: "UIModalContent"
});
const r = t({
  __name: "ModalContent",
  setup(s) {
    return (e, c) => (o(), n("div", l, [
      a(e.$slots, "default")
    ]));
  }
}), _ = r;
export {
  _ as default
};
